import React from 'react'
import { CheckmarkMiddleLogo } from '@components'
import ConsentLogos from '../ConsentLogos'

const ConsentLogosShieldCheck = () => <ConsentLogos middleLogo={<CheckmarkMiddleLogo />} />

export default ConsentLogosShieldCheck
